import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { jobOffer } from 'job/model/job-offer.fragments';

import { ApiMutation } from '../../../../common/model/api.mutation';
import { JobOfferOutput } from '../model/job-offer.output';

export interface MoveJobOfferToColumnParams {
	readonly jobOfferId: string;
	readonly columnId: string;
	readonly moduleId: string;
}

@Injectable({ providedIn: 'root' })
export class MoveJobOfferToColumnApiMutation extends ApiMutation<
	JobOfferOutput,
	MoveJobOfferToColumnParams
> {
	client = 'iam';
	document = gql`
		mutation MoveJobOfferToColumn(
			$moduleId: UUID!
			$columnId: UUID!
			$jobOfferId: UUID!
		) {
			moveJobOfferToColumn(
				jobOfferId: $jobOfferId
				columnId: $columnId
				moduleId: $moduleId
			) {
				...JobOffer
			}
		}
		${jobOffer}
	`;
	method = 'moveJobOfferToColumn';
}
